import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { TRIP_STATUS_CLASSES } from 'src/app/crew-management-user/models/trip.model';

@Component({
  selector: 'app-trips-template',
  templateUrl: './trips-template.component.html',
  styleUrls: ['./trips-template.component.scss'],
  standalone: false,
})
export class TripsTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;

  tripStatus = '';
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;

  ngOnInit(): void {
    this.tripStatus = TRIP_STATUS_CLASSES[this.element.status];
  }
}
